import { DashboardContainer } from '@forwardflow/components/Dashboard'
import Icon from '@forwardflow/ui/Icons'
import { Tour } from 'antd'
import { Link, Outlet } from 'react-router-dom'
import { Select } from '@forwardflow/ui-v2'

import { RecommendedLead } from './analytics/RecommendedLead'
import { LeadConversationStats } from './analytics/LeadConversationStats'
import { useEffect, useRef, useState } from 'react'
import type { TourProps } from 'antd'
import { useGetAllRecommendedCampaign } from '../hooks'
import { IRecommendedCampaign } from '@forwardflow/types'

export const CampaignHome = () => {
   const { data: recommendedCampaigns } = useGetAllRecommendedCampaign()
   const [selectedDays, setSelectedDays] = useState<string>('All Time')
   const ref1 = useRef(null)
   const ref2 = useRef(null)

   const isTourDone = localStorage.getItem('isCampaignTourDone') === 'true'
   const [open, setOpen] = useState<boolean>(!isTourDone)

   const steps: TourProps['steps'] = [
      {
         title: null,
         description: (
            <div className="flex items-center px-6">
               <Icon name="TourIcon" />
               <p className="p-6 font-semibold">
                  You can active auto nurture Campaigns on the recommended lead
                  sources for the best results
               </p>
            </div>
         ),
         className: 'ff-tour-step',

         target: () => ref1.current,
      },
      {
         title: null,
         description: (
            <>
               <div className="flex items-center px-6">
                  <Icon name="TourIcon" />
                  <p className="p-6 font-semibold">
                     You can also active auto nurture Campaigns on any of your
                     lead sources from this table
                  </p>
               </div>
            </>
         ),
         className: 'ff-tour-step',
         placement: 'left',
         target: () => ref2.current,
      },
   ]

   useEffect(() => {
      if (!open) {
         localStorage.setItem('isCampaignTourDone', 'true')
      }
   }, [open])
   return (
      <DashboardContainer className="xl:!overflow-hidden !overflow-y-auto xl:h-[calc(100vh-80px)] h-full">
         <div className="flex flex-col h-full xl:overflow-hidden overflow-y-auto">
            <div className="bg-[#9061DA]/[0.05] h-[60px] rounded-xl flex items-center px-3 justify-between shrink-0">
               <div className="flex items-center gap-x-1">
                  <Link
                     to="/dashboard"
                     className="w-8 h-8 rounded-lg flex items-center justify-center hover:bg-white/10 transition-colors shrink-0"
                  >
                     <Icon
                        name="arrow-right"
                        className="rotate-180 fill-white"
                        width={18}
                        height={18}
                     />
                  </Link>

                  <nav className="flex items-center text-sm ml-3 min-w-0 overflow-hidden">
                     <Link to="/dashboard" className="text-white/30 hover:text-white/50 transition-colors shrink-0">
                        Home
                     </Link>
                     <span className="text-white/20 mx-2 shrink-0">/</span>
                     <span className="text-white font-medium">Campaigns</span>
                  </nav>
               </div>
               <div className="flex items-center">
                  <Select
                     className="min-w-[150px] dashboard-select !h-9 rounded"
                     placeholder="All Time"
                     defaultValue={selectedDays}
                     data={[{ label: 'Last 6 months', value: 'All Time' }]}
                     onChange={(value) => setSelectedDays(value as string)}
                  />
               </div>
            </div>
            <div className="flex flex-col gap-5 mt-5 xl:flex-row flex-1 min-h-0">
               <div className="xl:w-2/5 overflow-y-auto min-h-0">
                  <div ref={ref1} className="h-[182px]">
                     <RecommendedLead
                        recommendedCampaigns={
                           (recommendedCampaigns ||
                              []) as unknown as IRecommendedCampaign[]
                        }
                     />
                  </div>

                  <LeadConversationStats selectedDays={selectedDays} />
               </div>
               <div className="xl:w-3/5 flex flex-col min-h-0">
                  <div ref={ref2} className="flex flex-col min-h-0 flex-1">
                     <Outlet />
                  </div>
               </div>
            </div>
         </div>
         <Tour
            open={open}
            onClose={() => setOpen(false)}
            steps={steps}
            closeIcon={false}
            mask={{
               style: {
                  boxShadow: 'inset 0 0 15px #333',
               },
               color: 'rgba(24, 25, 29, 0.8)',
            }}
         />
      </DashboardContainer>
   )
}
